import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export enum SummaryType {
    Distributed = 1,
    Accrued = 2,
}

export default class AuditConfirmationCriteria extends Model.CriteriaBase {
    static typeName = "AuditConfirmationCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.today();

    @Attributes.Nullable()
    public investorId: number | null = null;

    public investorInvestmentId: number = 0;

    @Rules.Required()
    public type: SummaryType | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<AuditConfirmationCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Audit Confirmation Criteria";
    }
}